// Shared constants for avatar caching
// This file ensures the service worker and React store use the same values
// Note: Keep this in sync with Mercury/assets/scripts/avatar-cache-constants.js

export const AVATAR_CACHE_CONFIG = {
  // Cache duration in milliseconds (12 hours)
  CACHE_DURATION: 12 * 60 * 60 * 1000,

  // Cache name for service worker
  CACHE_NAME: 'staff-avatars-cache-v1',

  // API endpoint path
  AVATAR_ENDPOINT: '/staff-members/avatars',

  // Header name for cache timestamp
  CACHE_TIME_HEADER: 'sw-cached-time',
} as const
